import { Component, ChangeDetectionStrategy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TuiPrimitiveTextfieldComponent, AbstractTuiControl, TuiNativeFocusableElement } from '@taiga-ui/legacy';

import { CustomNamesItem, VisibilityEnum, VisibilityNames } from '../../types';

@Component({
  selector: 'app-custom-name',
  templateUrl: './custom-name.component.html',
  styleUrls: ['./custom-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomNameComponent extends AbstractTuiControl<CustomNamesItem | null> {
  @ViewChild(TuiPrimitiveTextfieldComponent)
  private readonly textfield?: TuiPrimitiveTextfieldComponent;

  @Input() label: string = '';
  @Input() showVisibilityOption: boolean = false;
  @Output() visibilityOptionChange: EventEmitter<void> = new EventEmitter<void>();

  visibilities: readonly any[] = [
    {
      value: VisibilityEnum.INVISIBLE,
      name: VisibilityNames[VisibilityEnum.INVISIBLE],
    },
    {
      value: VisibilityEnum.ADMINISTRATORS,
      name: VisibilityNames[VisibilityEnum.ADMINISTRATORS],
    },
    {
      value: VisibilityEnum.ALL,
      name: VisibilityNames[VisibilityEnum.ALL],
    },
  ];

  open: boolean = false;

  get nativeFocusableElement(): TuiNativeFocusableElement | null {
    return this.computedDisabled || !this.textfield ? null : this.textfield.nativeFocusableElement;
  }

  get focused(): boolean {
    return !!this.textfield && this.textfield.focused;
  }

  protected getFallbackValue(): CustomNamesItem | null {
    return null;
  }

  activeZoneChange(active: boolean) {
    this.open = active && this.open;
  }

  onValueChange(textValue: string): void {
    if (!!this.value) {
      this.value.title = textValue;
      this.updateValue(this.value);
    }
  }

  onFocused(focused: boolean): void {
    this.updateFocused(focused);
  }

  changeVisibility(visibilityOption: string) {
    if (!!this.value) {
      this.value!.visibilityOption = visibilityOption;
      this.open = false;
      this.updateValue(this.value);
      this.visibilityOptionChange.emit();
    }
  }

  get visibility(): string {
    return !!this.value?.visibilityOption ? VisibilityNames[this.value?.visibilityOption as VisibilityEnum] : '';
  }
}
